(function($) {

    $.projectsSlider = function () {
        $('.project-slider').each(function() {
            var slider = $(this);
            slider.slick({
                slidesToShow : 3,
                autoplay: true,
                autoplaySpeed: 4000,
                prevArrow: '<a class="prev"><i class="far fa-chevron-left"></i></a>',
                nextArrow: '<a class="next"><i class="far fa-chevron-right"></i></a>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                ]
            });
        });
    };

    $(document).ready(function() {
        $.projectsSlider();
    });

})( jQuery );
